<div *ngIf="client$ | async as client">
  <div class="add-account">
    <button type="button" mat-raised-button (click)="add()" *ngIf="!adding"
            title="Add Bank Account">Add</button>
    <div class="mat-elevation-z4">
      <form [formGroup]="form" novalidate (ngSubmit)="createAccount(client)" *ngIf="adding">
        <div class="form-grid">
          <mat-form-field>
            <input matInput placeholder="IBAN" formControlName="iban" />
            <mat-error *ngIf="form.get('iban').invalid && (form.get('iban').dirty || form.get('iban').touched)">
              <ng-container *ngIf="form.get('iban').errors.required">
                IBAN is required.
              </ng-container>
              <ng-container *ngIf="form.get('iban').errors.iban">
                IBAN is invalid.
              </ng-container>
            </mat-error>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="BIC" formControlName="bic" />
          </mat-form-field>
          <p>
            <mat-checkbox formControlName="is_verified">Verified</mat-checkbox>
          </p>
        </div>
        <div class="actions">
          <button type="submit" mat-button color="primary" [disabled]="!form.valid">Add</button>
          <button type="reset" mat-button
                  (click)="closeAdd()">Cancel</button>
        </div>
      </form>
    </div>
  </div>

  <div class="mat-elevation-z4">

    <table mat-table [dataSource]="client.bank_accounts">

      <ng-container matColumnDef="iban">
        <mat-header-cell *matHeaderCellDef>IBAN</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.iban | ibanFormatter}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="bic">
        <mat-header-cell *matHeaderCellDef>BIC</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.bic}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="is_verified">
        <mat-header-cell *matHeaderCellDef>Verified</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.verified_at ? 'yes' : 'no'}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="created_at">
        <mat-header-cell *matHeaderCellDef>Created</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.created_at | date:'shortDate' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <button type="button" mat-icon-button (click)="$event.stopPropagation()" #trigger=matMenuTrigger
                  [matMenuTriggerFor]="bankAccountMenu" [matMenuTriggerData]="{account: element}">
            <mat-icon>more_vert</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: columns" matRipple [ngClass]="row.verified_at ? 'verified' : 'unverified'">
      </mat-row>

    </table>

    <mat-menu #bankAccountMenu="matMenu">
      <ng-template matMenuContent let-account="account">
        <ng-container *ngIf="!account.verified_at">
          <button mat-menu-item (click)="verify(client, account)">
            <mat-icon>fact_check</mat-icon>
            <span>Mark as verified</span>
          </button>
        </ng-container>
        <ng-container *ngIf="account.verified_at">
          <button mat-menu-item (click)="unverify(client, account)">
            <mat-icon>fact_check</mat-icon>
            <span>Mark as not verified</span>
          </button>
        </ng-container>
        <ng-container>
          <button mat-menu-item (click)="confirmDelete(client, account)">
            <mat-icon>delete</mat-icon>
            <span>Delete</span>
          </button>
        </ng-container>
      </ng-template>
    </mat-menu>
  </div>
</div>
